import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "@/components/ui/dialog";

export const PolicyDialog = ({ open, onOpenChange, policy }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent
      data-testid={`policy-dialog-${policy.id}`}
      className="max-w-2xl max-h-[85vh] overflow-y-auto bg-[#f7f0eb] border-2 border-[#111111] text-[#111111] rounded-3xl"
    >
      <DialogHeader>
        <DialogTitle
          data-testid={`policy-title-${policy.id}`}
          className="font-display text-2xl text-[#111111]"
        >
          {policy.title}
        </DialogTitle>
        <DialogDescription className="text-[#3d3d3d]/70">
          {policy.updated}
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-5">
        {policy.sections.map((s) => (
          <section key={s.heading}>
            <h4 className="font-display font-semibold text-lg text-[#111111] mb-1.5">
              {s.heading}
            </h4>
            {s.body.map((p, j) => (
              <p key={`${s.heading}-${j}`} className="text-sm text-[#3d3d3d] leading-relaxed mb-2">
                {p}
              </p>
            ))}
          </section>
        ))}
      </div>
    </DialogContent>
  </Dialog>
);
